<script setup lang="ts">
const dayjs = useDayjs()
const dayNames = dayjs.weekdaysShort(true)
</script>

<template>
  <div class="flex flex-row bg-brand-secondary-900 text-brand-white">
    <div
      v-for="(day, index) in dayNames"
      :key="index"
      class="w-10 h-10 text-sm flex items-center justify-center"
    >
      {{ day }}
    </div>
  </div>
</template>
